import { BundleInput, BundleStatusEnum } from '#types';

// The preferred order is: contract → invoice → proposal
export const getNextDocumentPathToEditInBundle = (
	bundle?: Omit<BundleInput, 'contactID' | 'eventDate'>
) =>
	bundle?.contractBundleStatus === BundleStatusEnum.Awaiting
		? '/contract/create'
		: bundle?.invoiceBundleStatus === BundleStatusEnum.Awaiting
			? '/invoice/create'
			: bundle?.proposalBundleStatus === BundleStatusEnum.Awaiting
				? '/proposal/create'
				: undefined;
